import { render } from "./DahuiyuanIntroduce.vue?vue&type=template&id=94b2f968&scoped=true"
import script from "./DahuiyuanIntroduce.vue?vue&type=script&lang=js"
export * from "./DahuiyuanIntroduce.vue?vue&type=script&lang=js"

import "./DahuiyuanIntroduce.vue?vue&type=style&index=0&id=94b2f968&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b2f968"]])

export default __exports__